// @ts-nocheck
// TODO: tighten types after migration
import * as React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./footer";
import App from "./App";
import Breadcrumbs from "./components/Breadcrumbs";
import NotFound from "./components/NotFound";
import Contact from "./Contact";
import Blog from "./Blog/Blog";
import Post from "./Blog/Post";
import BlogPage from "./Blog/Blogpage";
// eslint-disable-next-line no-unused-vars
import AdjacentPosts from "./Blog/AdjacentPosts";
import CategoryPosts from "./Blog/CategoryPosts";
// Removed unused imports to satisfy linter
import EditProfile from "./Auth/EditProfile";
import Signin from "./Auth/Signin";
import ForgotPassword from "./Auth/ForgotPassword";
import Store from "./Store/Store";
import Product from "./Store/Product";
import Cart from "./Store/Cart";
import Checkout from "./Store/Checkout";
import OrderSuccess from "./Store/OrderSuccess";
import OrderHistory from "./Store/OrderHistory";

// Admin
import Admin from "./Admin/Admin";
import AdminDatabase from "./Admin/AdminDatabase";
import CollectionDetail from "./Admin/CollectionDetail";
import EditDocument from "./Admin/EditDocument";
import CreateDocument from "./Admin/CreateDocument";
import OrderDetails from "./Admin/OrderDetails";
import EmailTemplateEditor from "./Admin/EmailTemplateEditor";
import NewsletterTemplateEditor from "./Admin/NewsletterTemplateEditor";
import AdminDashboard from "./Admin/AdminDashboard";
import StoreOrders from "./Admin/StoreOrders";
import AdminAppStoreSettings from "./Admin/AdminAppStoreSettings";
import AdminBrandMyLaptop from "./Admin/AdminBrandMyLaptop";
import BrandMyLaptop from "./BrandMyLaptop/BrandMyLaptop";

// Podcast import
import Podcast from "./Podcast/Podcast";

import PodcastEpisode from "./Podcast/PodcastEpisode";
import GlobalAudioPlayer from "./Podcast/GlobalAudioPlayer";

import SafariBottomBar from "./components/SafariBottomBar";
import AppStore from "./AppStore/AppStore";
import Pomodoro from "./Pomodoro/Pomodoro";
import LearnWithAI from "./AppStore/LearnWithAI/LearnWithAI";
import Typewriting from "./AppStore/Typewriting/Typewriting";
import KnowMe from "./AppStore/KnowMe/KnowMe";
import KnowMePublic from "./AppStore/KnowMe/KnowMePublic";
import Seo from "./AppStore/Seo/Seo";
import HabitTracker from "./AppStore/HabitTracker/HabitTracker";
import BookStore from "./AppStore/BookStore/BookStore";
import BookDetails from "./AppStore/BookStore/BookDetails";
import OwnBooks from "./AppStore/BookStore/OwnBooks";
import OwnBookReader from "./AppStore/BookStore/OwnBookReader";
import Market from "./AppStore/Market/Market";
import MyWealth from "./AppStore/MyWealth/MyWealth";
import MyWealthPublicProfile from "./AppStore/MyWealth/MyWealthPublicProfile";
import { RegionProvider } from "./context/RegionContext";
import { LanguageProvider } from "./context/LanguageContext";
import RegionPopup from "./components/RegionPopup";
import UserHeartbeat from "./components/UserHeartbeat";
import SubscriptionPaywall from "./components/SubscriptionPaywall";
import SubscriptionPlans from "./Subscription/SubscriptionPlans";
import InAppBrowserRedirect from "./components/InAppBrowserRedirect";
import { getSubdomain, isLocalhost } from "./utils/subdomain";

const isStoreSubdomain =
  typeof window !== "undefined" &&
  (window.location.hostname === "store.harivishnu.in" ||
   window.location.hostname === "www.store.harivishnu.in" ||
   window.location.hostname === "store.localhost" ||
   window.location.hostname.startsWith("store."));

function CanonicalUrlGuard() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    const isLocalHost = isLocalhost();

    let changed = false;

    if (!isLocalHost) {
      if (url.protocol !== "https:") {
        url.protocol = "https:";
        changed = true;
      }

      // Check if user is on any subdomain but requesting a main-domain route
      const isSubdomainHost = url.hostname.endsWith(".harivishnu.in") && url.hostname !== "www.harivishnu.in" && url.hostname !== "harivishnu.in";
      if (isSubdomainHost) {
        if (
          url.pathname === "/subscription" || url.pathname.startsWith("/subscription/") ||
          url.pathname === "/contact" || url.pathname.startsWith("/contact/") ||
          url.pathname === "/about" || url.pathname.startsWith("/about/") ||
          url.pathname === "/signin" || url.pathname.startsWith("/signin/") ||
          url.pathname === "/forgot-password" || url.pathname.startsWith("/forgot-password/") ||
          url.pathname === "/edit-profile" || url.pathname.startsWith("/edit-profile/")
        ) {
          url.hostname = "www.harivishnu.in";
          changed = true;
        }
      }

      // 1. If user is on store.harivishnu.in
      if (url.hostname === "store.harivishnu.in" || url.hostname === "www.store.harivishnu.in") {
        if (url.hostname === "www.store.harivishnu.in") {
          url.hostname = "store.harivishnu.in";
          changed = true;
        }

        // Clean /store prefix on store subdomain
        if (url.pathname === "/store" || url.pathname === "/store/") {
          url.pathname = "/";
          changed = true;
        } else if (url.pathname.startsWith("/store/")) {
          url.pathname = url.pathname.replace(/^\/store/, "");
          changed = true;
        }

        // Cross-subdomain redirects
        if (url.pathname.startsWith("/blog") || url.pathname.startsWith("/blogpage") || url.pathname.startsWith("/category/")) {
          url.hostname = "blog.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/podcast")) {
          url.hostname = "podcast.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/app-store") || url.pathname.startsWith("/pomodoro") || url.pathname.startsWith("/learnwithai") || url.pathname.startsWith("/typewriting") || url.pathname.startsWith("/knowme") || url.pathname.startsWith("/seo") || url.pathname.startsWith("/habit-tracker") || url.pathname.startsWith("/bookstore") || url.pathname.startsWith("/market") || url.pathname.startsWith("/markets") || url.pathname.startsWith("/brand-my-laptop") || url.pathname.startsWith("/mac-sponsor")) {
          url.hostname = "apps.harivishnu.in";
          changed = true;
        }
      } else if (url.hostname === "blog.harivishnu.in" || url.hostname === "www.blog.harivishnu.in") {
        // 2. If user is on blog.harivishnu.in
        if (url.hostname === "www.blog.harivishnu.in") {
          url.hostname = "blog.harivishnu.in";
          changed = true;
        }

        // Clean /blog prefix on blog subdomain
        if (url.pathname === "/blog" || url.pathname === "/blog/") {
          url.pathname = "/";
          changed = true;
        } else if (url.pathname.startsWith("/blog/")) {
          url.pathname = url.pathname.replace(/^\/blog/, "");
          changed = true;
        }

        // Cross-subdomain redirects
        if (url.pathname.startsWith("/store") || url.pathname.startsWith("/cart") || url.pathname.startsWith("/checkout") || url.pathname.startsWith("/order-history") || url.pathname.startsWith("/order-success")) {
          url.hostname = "store.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/podcast")) {
          url.hostname = "podcast.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/app-store") || url.pathname.startsWith("/pomodoro") || url.pathname.startsWith("/learnwithai") || url.pathname.startsWith("/typewriting") || url.pathname.startsWith("/knowme") || url.pathname.startsWith("/seo") || url.pathname.startsWith("/habit-tracker") || url.pathname.startsWith("/bookstore") || url.pathname.startsWith("/market") || url.pathname.startsWith("/markets") || url.pathname.startsWith("/brand-my-laptop") || url.pathname.startsWith("/mac-sponsor")) {
          url.hostname = "apps.harivishnu.in";
          changed = true;
        }
      } else if (url.hostname === "podcast.harivishnu.in" || url.hostname === "www.podcast.harivishnu.in") {
        // 3. If user is on podcast.harivishnu.in
        if (url.hostname === "www.podcast.harivishnu.in") {
          url.hostname = "podcast.harivishnu.in";
          changed = true;
        }

        // Clean /podcast prefix on podcast subdomain
        if (url.pathname === "/podcast" || url.pathname === "/podcast/") {
          url.pathname = "/";
          changed = true;
        } else if (url.pathname.startsWith("/podcast/")) {
          url.pathname = url.pathname.replace(/^\/podcast/, "");
          changed = true;
        }

        // Cross-subdomain redirects
        if (url.pathname.startsWith("/store") || url.pathname.startsWith("/cart") || url.pathname.startsWith("/checkout") || url.pathname.startsWith("/order-history") || url.pathname.startsWith("/order-success")) {
          url.hostname = "store.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/blog") || url.pathname.startsWith("/blogpage") || url.pathname.startsWith("/category/")) {
          url.hostname = "blog.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/app-store") || url.pathname.startsWith("/pomodoro") || url.pathname.startsWith("/learnwithai") || url.pathname.startsWith("/typewriting") || url.pathname.startsWith("/knowme") || url.pathname.startsWith("/seo") || url.pathname.startsWith("/habit-tracker") || url.pathname.startsWith("/bookstore") || url.pathname.startsWith("/market") || url.pathname.startsWith("/markets") || url.pathname.startsWith("/brand-my-laptop") || url.pathname.startsWith("/mac-sponsor")) {
          url.hostname = "apps.harivishnu.in";
          changed = true;
        }
      } else if (url.hostname === "apps.harivishnu.in" || url.hostname === "www.apps.harivishnu.in") {
        // 4. If user is on apps.harivishnu.in
        if (url.hostname === "www.apps.harivishnu.in") {
          url.hostname = "apps.harivishnu.in";
          changed = true;
        }

        // Clean /app-store prefix on apps subdomain
        if (url.pathname === "/app-store" || url.pathname === "/app-store/") {
          url.pathname = "/";
          changed = true;
        } else if (url.pathname.startsWith("/app-store/")) {
          url.pathname = url.pathname.replace(/^\/app-store/, "");
          changed = true;
        }

        // Cross-subdomain redirects
        if (url.pathname.startsWith("/store") || url.pathname.startsWith("/cart") || url.pathname.startsWith("/checkout") || url.pathname.startsWith("/order-history") || url.pathname.startsWith("/order-success")) {
          url.hostname = "store.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/blog") || url.pathname.startsWith("/blogpage") || url.pathname.startsWith("/category/")) {
          url.hostname = "blog.harivishnu.in";
          changed = true;
        } else if (url.pathname.startsWith("/podcast")) {
          url.hostname = "podcast.harivishnu.in";
          changed = true;
        }
      } else if (url.hostname === "contact.harivishnu.in" || url.hostname === "www.contact.harivishnu.in") {
        // Redirect legacy contact subdomain back to www.harivishnu.in/contact
        url.hostname = "www.harivishnu.in";
        url.pathname = "/contact";
        changed = true;
      } else if (url.hostname === "harivishnu.in") {
        url.hostname = "www.harivishnu.in";
        changed = true;
      }
    } else {
      // Localhost environment: clean redundant prefixes if on apps subdomain
      if (url.hostname.startsWith("apps.")) {
        if (url.pathname === "/app-store" || url.pathname === "/app-store/") {
          url.pathname = "/";
          changed = true;
        } else if (url.pathname.startsWith("/app-store/")) {
          url.pathname = url.pathname.replace(/^\/app-store/, "");
          changed = true;
        }
      }
    }

    if (url.pathname.length > 1) {
      const dedupedPath = url.pathname.replace(/\/{2,}/g, "/");
      if (dedupedPath !== url.pathname) {
        url.pathname = dedupedPath;
        changed = true;
      }
    }

    if (changed) {
      window.location.replace(url.toString());
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}

// Redirects www.harivishnu.in/store to store.harivishnu.in
function StoreLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/store/, "");
      const newUrl = `https://store.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return <Store />;
}

// Redirects www.harivishnu.in/store/:slug to store.harivishnu.in/:slug
function ProductLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/store/, "");
      const newUrl = `https://store.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <Header />
      <Breadcrumbs />
      <Product />
      <Footer />
    </>
  );
}

// Redirects www.harivishnu.in/blog to blog.harivishnu.in
function BlogLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/blog/, "");
      const newUrl = `https://blog.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return <Blog />;
}

// Redirects www.harivishnu.in/blog/... to blog.harivishnu.in/...
function BlogPostLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/blog/, "");
      const newUrl = `https://blog.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <Header />
      <Post />
      <Footer />
    </>
  );
}

// Redirects www.harivishnu.in/blogpage to blog.harivishnu.in/blogpage
function BlogPageLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const newUrl = `https://blog.harivishnu.in/blogpage${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return <BlogPage />;
}

// Redirects www.harivishnu.in/podcast to podcast.harivishnu.in
function PodcastLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/podcast/, "");
      const newUrl = `https://podcast.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return <Podcast />;
}

// Redirects www.harivishnu.in/podcast/:slug to podcast.harivishnu.in/:slug
function PodcastEpisodeLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/podcast/, "");
      const newUrl = `https://podcast.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return <PodcastEpisode />;
}

// Redirects www.harivishnu.in/app-store to apps.harivishnu.in
function AppStoreLegacyRedirect() {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/app-store/, "");
      const newUrl = `https://apps.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <Header />
      <AppStore />
      <Footer />
    </>
  );
}

// Redirects www.harivishnu.in/app-store/* to apps.harivishnu.in/*
function AppStoreSubRouteLegacyRedirect({ element }) {
  const location = useLocation();

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const isLocal = isLocalhost();

    if (!isLocal) {
      const remainingPath = location.pathname.replace(/^\/app-store/, "");
      const newUrl = `https://apps.harivishnu.in${remainingPath || "/"}${location.search}${location.hash}`;
      window.location.replace(newUrl);
    }
  }, [location.pathname, location.search, location.hash]);

  return element;
}

function SharedRoutes() {
  return (
    <>
      <Route path="/signin" element={<Signin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/edit-profile"
        element={
          <>
            <Header />
            <Breadcrumbs />
            <EditProfile />
            <Footer />
          </>
        }
      />
      <Route
        path="/subscription"
        element={
          <>
            <Header />
            <SubscriptionPlans />
            <Footer />
          </>
        }
      />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<Contact />} />

      {/* My Wealth Public Character Profile Routes */}
      <Route
        path="/profile/:username"
        element={
          <>
            <Header />
            <MyWealthPublicProfile />
            <Footer />
          </>
        }
      />
      <Route
        path="/profile/:username/*"
        element={
          <>
            <Header />
            <MyWealthPublicProfile />
            <Footer />
          </>
        }
      />
      <Route
        path="/finance-world/profile/:username"
        element={
          <>
            <Header />
            <MyWealthPublicProfile />
            <Footer />
          </>
        }
      />
      <Route
        path="/finance-world/profile/:username/*"
        element={
          <>
            <Header />
            <MyWealthPublicProfile />
            <Footer />
          </>
        }
      />


      {/* Admin Routes */}
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/dashboard" element={<Admin />} />
      <Route
        path="/admin/app-store-settings"
        element={
          <>
            <Header />
            <AdminAppStoreSettings />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/brand-my-laptop"
        element={
          <>
            <Header />
            <AdminBrandMyLaptop />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/user-dashboard"
        element={
          <>
            <Header />

            <AdminDashboard />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/store-orders"
        element={
          <>
            <Header />
            <StoreOrders />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/orders/:orderId"
        element={
          <>
            <Header />
            <OrderDetails />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database"
        element={
          <>
            <Header />
            <AdminDatabase />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/creddb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/creddb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/creddb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/creddb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/blogdb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/blogdb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/blogdb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/blogdb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/EmailTemplates/create"
        element={
          <>
            <Header />
            <NewsletterTemplateEditor />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/EmailTemplates/edit/:documentId"
        element={
          <>
            <Header />
            <NewsletterTemplateEditor />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsletterdb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/podcastdb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/podcastdb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/podcastdb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/podcastdb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/PurchaseOrders"
        element={
          <>
            <Header />
            <StoreOrders fromDatabase />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/EmailTemplates/create"
        element={
          <>
            <Header />
            <EmailTemplateEditor />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/EmailTemplates/edit/:documentId"
        element={
          <>
            <Header />
            <EmailTemplateEditor />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/storedb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/sponsorshipdb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/sponsorshipdb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/sponsorshipdb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/sponsorshipdb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/userthoughts/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/userthoughts/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/userthoughts/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/userthoughts/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/learnwithai/:collectionName"
        element={<><Header /><CollectionDetail /><Footer /></>}
      />
      <Route
        path="/admin/database/learnwithai/:collectionName/create"
        element={<><Header /><CreateDocument /><Footer /></>}
      />
      <Route
        path="/admin/database/learnwithai/:collectionName/edit/:documentId"
        element={<><Header /><EditDocument /><Footer /></>}
      />
      <Route
        path="/admin/database/learnwithai/:collectionName/view/:documentId"
        element={<><Header /><EditDocument /><Footer /></>}
      />
      <Route
        path="/admin/database/newsroomdb/:collectionName"
        element={
          <>
            <Header />
            <CollectionDetail />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsroomdb/:collectionName/create"
        element={
          <>
            <Header />
            <CreateDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsroomdb/:collectionName/edit/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
      <Route
        path="/admin/database/newsroomdb/:collectionName/view/:documentId"
        element={
          <>
            <Header />
            <EditDocument />
            <Footer />
          </>
        }
      />
    </>
  );
}

function AppRoutes() {
  const currentSubdomain = typeof window !== "undefined" ? getSubdomain(window.location.hostname) : "";
  const isStore = currentSubdomain === "store";
  const isBlog = currentSubdomain === "blog";
  const isPodcast = currentSubdomain === "podcast";
  const isApps = currentSubdomain === "apps";

  if (isApps) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <AppStore />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store"
          element={
            <>
              <Header />
              <AppStore />
              <Footer />
            </>
          }
        />
        <Route path="/pomodoro" element={<Pomodoro />} />
        <Route path="/app-store/pomodoro" element={<Pomodoro />} />
        <Route
          path="/learnwithai"
          element={
            <>
              <Header />
              <LearnWithAI />
            </>
          }
        />
        <Route
          path="/app-store/learnwithai"
          element={
            <>
              <Header />
              <LearnWithAI />
            </>
          }
        />
        <Route
          path="/typewriting"
          element={
            <>
              <Header />
              <Typewriting />
            </>
          }
        />
        <Route
          path="/app-store/typewriting"
          element={
            <>
              <Header />
              <Typewriting />
            </>
          }
        />
        <Route
          path="/knowme"
          element={
            <SubscriptionPaywall>
              <Header />
              <KnowMe />
            </SubscriptionPaywall>
          }
        />
        <Route
          path="/app-store/knowme"
          element={
            <SubscriptionPaywall>
              <Header />
              <KnowMe />
            </SubscriptionPaywall>
          }
        />
        <Route
          path="/knowme/:username/*"
          element={
            <>
              <Header />
              <KnowMePublic />
            </>
          }
        />
        <Route
          path="/app-store/knowme/:username/*"
          element={
            <>
              <Header />
              <KnowMePublic />
            </>
          }
        />
        <Route
          path="/seo"
          element={
            <SubscriptionPaywall featureKey="seo">
              <Header />
              <Seo />
            </SubscriptionPaywall>
          }
        />
        <Route
          path="/app-store/seo"
          element={
            <SubscriptionPaywall featureKey="seo">
              <Header />
              <Seo />
            </SubscriptionPaywall>
          }
        />
        <Route
          path="/habit-tracker"
          element={
            <>
              <Header />
              <HabitTracker />
            </>
          }
        />
        <Route
          path="/app-store/habit-tracker"
          element={
            <>
              <Header />
              <HabitTracker />
            </>
          }
        />
        <Route
          path="/bookstore"
          element={
            <>
              <Header />
              <BookStore />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/bookstore"
          element={
            <>
              <Header />
              <BookStore />
              <Footer />
            </>
          }
        />
        <Route
          path="/bookstore/own-books"
          element={
            <>
              <Header />
              <OwnBooks />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/bookstore/own-books"
          element={
            <>
              <Header />
              <OwnBooks />
              <Footer />
            </>
          }
        />
        <Route
          path="/bookstore/own-books/read/:bookId"
          element={<OwnBookReader />}
        />
        <Route
          path="/app-store/bookstore/own-books/read/:bookId"
          element={<OwnBookReader />}
        />
        <Route
          path="/bookstore/:bookId"
          element={
            <>
              <Header />
              <BookDetails />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/bookstore/:bookId"
          element={
            <>
              <Header />
              <BookDetails />
              <Footer />
            </>
          }
        />
        <Route
          path="/market"
          element={
            <>
              <Header />
              <Market />
              <Footer />
            </>
          }
        />
        <Route
          path="/markets"
          element={
            <>
              <Header />
              <Market />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/market"
          element={
            <>
              <Header />
              <Market />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/markets"
          element={
            <>
              <Header />
              <Market />
              <Footer />
            </>
          }
        />
        <Route
          path="/brand-my-laptop"
          element={
            <>
              <Header />
              <BrandMyLaptop />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/brand-my-laptop"
          element={
            <>
              <Header />
              <BrandMyLaptop />
              <Footer />
            </>
          }
        />
        <Route
          path="/mac-sponsor"
          element={
            <>
              <Header />
              <BrandMyLaptop />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/mac-sponsor"
          element={
            <>
              <Header />
              <BrandMyLaptop />
              <Footer />
            </>
          }
        />
        <Route
          path="/finance-world"
          element={
            <>
              <Header />
              <MyWealth />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/finance-world"
          element={
            <>
              <Header />
              <MyWealth />
              <Footer />
            </>
          }
        />
        <Route
          path="/my-wealth"
          element={
            <>
              <Header />
              <MyWealth />
              <Footer />
            </>
          }
        />
        <Route
          path="/app-store/my-wealth"
          element={
            <>
              <Header />
              <MyWealth />
              <Footer />
            </>
          }
        />

        {/* Shared Auth, Admin, Subscription, and Contact Routes */}
        {SharedRoutes()}

        {/* Cross-subdomain redirects */}
        <Route path="/store" element={<StoreLegacyRedirect />} />
        <Route path="/store/:slug/*" element={<ProductLegacyRedirect />} />
        <Route path="/cart" element={<StoreLegacyRedirect />} />
        <Route path="/checkout" element={<StoreLegacyRedirect />} />
        <Route path="/order-history" element={<StoreLegacyRedirect />} />
        <Route path="/order-success" element={<StoreLegacyRedirect />} />

        <Route path="/podcast" element={<PodcastLegacyRedirect />} />
        <Route path="/podcast/:slug/*" element={<PodcastEpisodeLegacyRedirect />} />

        <Route path="/blog" element={<BlogLegacyRedirect />} />
        <Route path="/blog/:blogid/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/:slug/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blogpage/*" element={<BlogPageLegacyRedirect />} />
        <Route path="/category/:categoryName/*" element={<BlogPageLegacyRedirect />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  if (isPodcast) {
    return (
      <Routes>
        {/* Podcast Homepage */}
        <Route path="/" element={<Podcast />} />
        <Route path="/podcast" element={<Podcast />} />

        {/* Shared Auth, Admin, Subscription, and Contact Routes - Must be before wildcard :slug */}
        {SharedRoutes()}

        {/* Cross-subdomain redirects */}
        <Route path="/store" element={<StoreLegacyRedirect />} />
        <Route path="/store/:slug/*" element={<ProductLegacyRedirect />} />
        <Route path="/cart" element={<StoreLegacyRedirect />} />
        <Route path="/checkout" element={<StoreLegacyRedirect />} />
        <Route path="/order-history" element={<StoreLegacyRedirect />} />
        <Route path="/order-success" element={<StoreLegacyRedirect />} />

        <Route path="/blog" element={<BlogLegacyRedirect />} />
        <Route path="/blog/:blogid/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/:slug/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blogpage/*" element={<BlogPageLegacyRedirect />} />
        <Route path="/category/:categoryName/*" element={<BlogPageLegacyRedirect />} />

        <Route path="/app-store" element={<AppStoreLegacyRedirect />} />
        <Route path="/app-store/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/pomodoro" element={<AppStoreSubRouteLegacyRedirect element={<Pomodoro />} />} />
        <Route path="/typewriting" element={<AppStoreSubRouteLegacyRedirect element={<Typewriting />} />} />
        <Route path="/learnwithai" element={<AppStoreSubRouteLegacyRedirect element={<LearnWithAI />} />} />
        <Route path="/knowme" element={<AppStoreSubRouteLegacyRedirect element={<KnowMe />} />} />
        <Route path="/seo" element={<AppStoreSubRouteLegacyRedirect element={<Seo />} />} />
        <Route path="/habit-tracker" element={<AppStoreSubRouteLegacyRedirect element={<HabitTracker />} />} />
        <Route path="/bookstore" element={<AppStoreSubRouteLegacyRedirect element={<BookStore />} />} />
        <Route path="/bookstore/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/market" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/markets" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/finance-world" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/my-wealth" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/app-store/finance-world" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/app-store/my-wealth" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />

        {/* Podcast Episode Page */}
        <Route path="/podcast/:slug/*" element={<PodcastEpisode />} />
        <Route path="/:slug/*" element={<PodcastEpisode />} />

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  if (isStore) {
    return (
      <Routes>
        <Route path="/" element={<Store />} />
        <Route path="/store" element={<Store />} />
        <Route
          path="/cart"
          element={
            <>
              <Header />
              <Breadcrumbs />
              <Cart />
              <Footer />
            </>
          }
        />
        <Route
          path="/checkout"
          element={
            <>
              <Header />
              <Breadcrumbs />
              <Checkout />
              <Footer />
            </>
          }
        />
        <Route
          path="/order-success"
          element={
            <>
              <Header />
              <OrderSuccess />
              <Footer />
            </>
          }
        />
        <Route
          path="/order-history"
          element={
            <>
              <Header />
              <OrderHistory />
              <Footer />
            </>
          }
        />

        {/* Shared Auth, Admin, Subscription, and Contact Routes - Must be before wildcard :slug */}
        {SharedRoutes()}

        {/* Cross-subdomain redirects */}
        <Route path="/podcast" element={<PodcastLegacyRedirect />} />
        <Route path="/podcast/:slug/*" element={<PodcastEpisodeLegacyRedirect />} />

        <Route path="/blog" element={<BlogLegacyRedirect />} />
        <Route path="/blog/:blogid/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/:slug/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blog/:categoryName/*" element={<BlogPostLegacyRedirect />} />
        <Route path="/blogpage/*" element={<BlogPageLegacyRedirect />} />
        <Route path="/category/:categoryName/*" element={<BlogPageLegacyRedirect />} />

        <Route path="/app-store" element={<AppStoreLegacyRedirect />} />
        <Route path="/app-store/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/pomodoro" element={<AppStoreSubRouteLegacyRedirect element={<Pomodoro />} />} />
        <Route path="/typewriting" element={<AppStoreSubRouteLegacyRedirect element={<Typewriting />} />} />
        <Route path="/learnwithai" element={<AppStoreSubRouteLegacyRedirect element={<LearnWithAI />} />} />
        <Route path="/knowme" element={<AppStoreSubRouteLegacyRedirect element={<KnowMe />} />} />
        <Route path="/seo" element={<AppStoreSubRouteLegacyRedirect element={<Seo />} />} />
        <Route path="/habit-tracker" element={<AppStoreSubRouteLegacyRedirect element={<HabitTracker />} />} />
        <Route path="/bookstore" element={<AppStoreSubRouteLegacyRedirect element={<BookStore />} />} />
        <Route path="/bookstore/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/market" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/markets" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />

        <Route
          path="/store/:slug/*"
          element={
            <>
              <Header />
              <Breadcrumbs />
              <Product />
              <Footer />
            </>
          }
        />
        <Route
          path="/:slug/*"
          element={
            <>
              <Header />
              <Breadcrumbs />
              <Product />
              <Footer />
            </>
          }
        />
        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  if (isBlog) {
    return (
      <Routes>
        {/* Blog Homepage */}
        <Route path="/" element={<Blog />} />
        <Route path="/blog" element={<Blog />} />

        {/* Blog Search & Filter Page */}
        <Route path="/blogpage/*" element={<BlogPage />} />

        {/* Category Posts: e.g. /technology, /business */}
        <Route path="/category/:categoryName/*" element={<CategoryPosts />} />

        {/* Shared Auth, Admin, Subscription, and Contact Routes - Must be before wildcard :categoryName/:slug */}
        {SharedRoutes()}

        {/* Cross-subdomain redirects */}
        <Route path="/store" element={<StoreLegacyRedirect />} />
        <Route path="/store/:slug/*" element={<ProductLegacyRedirect />} />
        <Route path="/cart" element={<StoreLegacyRedirect />} />
        <Route path="/checkout" element={<StoreLegacyRedirect />} />
        <Route path="/order-history" element={<StoreLegacyRedirect />} />
        <Route path="/order-success" element={<StoreLegacyRedirect />} />

        <Route path="/podcast" element={<PodcastLegacyRedirect />} />
        <Route path="/podcast/:slug/*" element={<PodcastEpisodeLegacyRedirect />} />

        <Route path="/app-store" element={<AppStoreLegacyRedirect />} />
        <Route path="/app-store/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/pomodoro" element={<AppStoreSubRouteLegacyRedirect element={<Pomodoro />} />} />
        <Route path="/typewriting" element={<AppStoreSubRouteLegacyRedirect element={<Typewriting />} />} />
        <Route path="/learnwithai" element={<AppStoreSubRouteLegacyRedirect element={<LearnWithAI />} />} />
        <Route path="/knowme" element={<AppStoreSubRouteLegacyRedirect element={<KnowMe />} />} />
        <Route path="/seo" element={<AppStoreSubRouteLegacyRedirect element={<Seo />} />} />
        <Route path="/habit-tracker" element={<AppStoreSubRouteLegacyRedirect element={<HabitTracker />} />} />
        <Route path="/bookstore" element={<AppStoreSubRouteLegacyRedirect element={<BookStore />} />} />
        <Route path="/bookstore/*" element={<AppStoreLegacyRedirect />} />
        <Route path="/market" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/markets" element={<AppStoreSubRouteLegacyRedirect element={<Market />} />} />
        <Route path="/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/brand-my-laptop" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/app-store/mac-sponsor" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><BrandMyLaptop /><Footer /></>} />} />
        <Route path="/finance-world" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/my-wealth" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/app-store/finance-world" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />
        <Route path="/app-store/my-wealth" element={<AppStoreSubRouteLegacyRedirect element={<><Header /><MyWealth /><Footer /></>} />} />

        {/* Legacy /blog/category/slug paths on blog subdomain */}
        <Route
          path="/blog/:categoryName/:slug/*"
          element={
            <>
              <Header />
              <Post />
              <Footer />
            </>
          }
        />
        <Route
          path="/blog/:blogid/*"
          element={
            <>
              <Header />
              <Post />
              <Footer />
            </>
          }
        />
        <Route path="/blog/:categoryName/*" element={<CategoryPosts />} />

        {/* Direct category post links (category/slug) */}
        <Route
          path="/:categoryName/:slug/*"
          element={
            <>
              <Header />
              <Post />
              <Footer />
            </>
          }
        />

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<App />} />

      {/* Shared Auth, Admin, Subscription, and Contact Routes */}
      {SharedRoutes()}

      {/* Legacy Podcast Routes (redirect to podcast.harivishnu.in) */}
      <Route path="/podcast" element={<PodcastLegacyRedirect />} />
      <Route
        path="/podcast/:slug/*"
        element={<PodcastEpisodeLegacyRedirect />}
      />

      {/* Legacy Blog Routes (redirect to blog.harivishnu.in) */}
      <Route path="/blog" element={<BlogLegacyRedirect />} />
      <Route
        path="/blog/:blogid/*"
        element={<BlogPostLegacyRedirect />}
      />
      <Route
        path="/blog/:categoryName/:slug/*"
        element={<BlogPostLegacyRedirect />}
      />
      <Route path="/blog/:categoryName/*" element={<BlogPostLegacyRedirect />} />
      <Route path="/blogpage/*" element={<BlogPageLegacyRedirect />} />
      <Route path="/category/:categoryName/*" element={<BlogPageLegacyRedirect />} />

      {/* Legacy Store Routes (redirect to store.harivishnu.in) */}
      <Route path="/store" element={<StoreLegacyRedirect />} />
      <Route
        path="/store/:slug/*"
        element={<ProductLegacyRedirect />}
      />

      <Route
        path="/cart"
        element={
          <>
            <Header />
            <Breadcrumbs />
            <Cart />
            <Footer />
          </>
        }
      />
      <Route
        path="/checkout"
        element={
          <>
            <Header />
            <Checkout />
            <Footer />
          </>
        }
      />
      <Route
        path="/order-success"
        element={
          <>
            <Header />
            <OrderSuccess />
            <Footer />
          </>
        }
      />
      <Route
        path="/order-history"
        element={
          <>
            <Header />
            <OrderHistory />
            <Footer />
          </>
        }
      />

      <Route
        path="/app-store"
        element={<AppStoreLegacyRedirect />}
      />
      <Route
        path="/app-store/pomodoro"
        element={<AppStoreSubRouteLegacyRedirect element={<Pomodoro />} />}
      />
      <Route
        path="/app-store/learnwithai"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <LearnWithAI />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/typewriting"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <Typewriting />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/knowme"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <SubscriptionPaywall>
                <Header />
                <KnowMe />
              </SubscriptionPaywall>
            }
          />
        }
      />
      <Route
        path="/app-store/knowme/:username/*"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <KnowMePublic />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/seo"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <SubscriptionPaywall featureKey="seo">
                <Header />
                <Seo />
              </SubscriptionPaywall>
            }
          />
        }
      />
      <Route
        path="/app-store/habit-tracker"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <HabitTracker />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/bookstore"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BookStore />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/bookstore/own-books"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <OwnBooks />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/bookstore/own-books/read/:bookId"
        element={<AppStoreSubRouteLegacyRedirect element={<OwnBookReader />} />}
      />
      <Route
        path="/app-store/bookstore/:bookId"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BookDetails />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/market"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <Market />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/markets"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <Market />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/market"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <Market />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/markets"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <Market />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/brand-my-laptop"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BrandMyLaptop />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/brand-my-laptop"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BrandMyLaptop />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/mac-sponsor"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BrandMyLaptop />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/mac-sponsor"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <BrandMyLaptop />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/finance-world"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <MyWealth />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/my-wealth"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <MyWealth />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/finance-world"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <MyWealth />
                <Footer />
              </>
            }
          />
        }
      />
      <Route
        path="/app-store/my-wealth"
        element={
          <AppStoreSubRouteLegacyRedirect
            element={
              <>
                <Header />
                <MyWealth />
                <Footer />
              </>
            }
          />
        }
      />

      {/* 404 Route - Must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const routing = (
  <RegionProvider>
    <LanguageProvider>
      <Router>
        <CanonicalUrlGuard />
        <InAppBrowserRedirect />
        <AppRoutes />

        {/* Global Audio Player - Always rendered, synced across all pages */}
        <GlobalAudioPlayer />

        {/* Region Popup - Always rendered, handles visibility via context */}
        <RegionPopup />

        {/* User Heartbeat - Tracks online status for logged-in users */}
        <UserHeartbeat />

        {/* Force Safari Bottom Bar Color */}
        <SafariBottomBar />
      </Router>
    </LanguageProvider>
  </RegionProvider>
);

export default routing;
